import React from 'react';
import { BookBookmark } from 'phosphor-react';
import "./EmptyStates.css";

const EmptySubscribedNotes = () => {
    return (
        <div className="emptyContainer emptyContainer__myNotes">
            <div className="emptyContainer__icon--wrapper">
            <BookBookmark size={32} weight="fill" color="#FFFFFF" className="emptyContainer__icon"  />
            </div>
            <div className="emptyContainer__info">
            <h4 className="info__heading">No Notes subscribed yet!</h4>
            <p className="info__subtext">Subscribed (Paid, Free) notes <br /> will appear here</p>
            </div>
        </div>
    );
};

export default EmptySubscribedNotes;